import type * as React from 'react';
import type { FC, ReactNode } from 'react';
import { Box, Paper, Step, StepLabel, Stepper, Typography } from '@mui/material';

export interface StepType {
  title: string;
  component: React.ComponentType;
}

export interface StepperPaperProps {
  title?: string;
  steps: StepType[];
  activeStep: number;
  children?: ReactNode;
  topTabs?: ReactNode;
}

const StepperPaper: FC<StepperPaperProps> = ({ title, steps, activeStep, children, topTabs }) => {
  return (
    <>
      {topTabs}
      <Box sx={{ flex: 1, display: 'flex' }}>
        <Paper
          variant="outlined"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            pt: { xs: 2, md: 3 },
            px: { xs: 2, md: 3 },
            border: 'none',
            borderRadius: '8px',
            overflow: 'hidden',
            overflowY: 'auto',
            boxShadow: '12px 13px 26px 5px rgb(163 145 203 / 6%)',
            width: '100%',
          }}
        >
          {title && (
            <Box sx={{ display: 'flex' }}>
              <Typography component="h1" variant="h6" align="left">
                {title}
              </Typography>
            </Box>
          )}
          <Stepper activeStep={activeStep} sx={{ pt: 3, pb: 5, '& .MuiStepIcon-text': { fontSize: '0.975rem' } }}>
            {steps.map((step) => (
              <Step key={step.title}>
                <StepLabel>{step.title}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {children}
        </Paper>
      </Box>
    </>
  );
};

export default StepperPaper;
